/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Alert24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Alert 24">
      <circle cx={12} cy={12} r={10} fill="#F33" className="Fill-Main" />
      <path
        fill="#fff"
        d="M11 7a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0V7Zm2 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        className="Details"
      />
    </g>
  </svg>
);
const Alert64 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 64 64"
    {...props}
  >
    <g className="Alert 64" clipPath="url(#a)">
      <circle cx={32} cy={32} r={32} fill="#F33" className="Fill-Main" />
      <path
        fill="#fff"
        d="M29 16a3 3 0 1 1 6 0v22a3 3 0 1 1-6 0V16Zm6 32a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        className="Details"
      />
    </g>
    <defs>
      <clipPath id="a" className="a">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);

const SIZE_MAP = {
  sm: Alert24,
  md: Alert24,
  lg: Alert24,
  xl: Alert24,
  xxl: Alert64,
  xxxl: Alert64,
};

export const AlertIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'alert-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
